<template>
  <section class="container">
    <div class="container-content" @click="updateViewable">
      <span id="title"> {{ title }} </span>
      <span v-if="count">({{ count }}) </span>
      <span v-show="!isViewable">
        <i class="fas fa-angle-down has-text-grey-light is-size-6" />
      </span>
      <span v-show="isViewable">
        <i class="fas fa-angle-up has-text-grey-light is-size-6" />
      </span>
    </div>
    <div v-show="isViewable">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "Container",
  props: {
    title: { type: String, required: true },
    viewable: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
  },
  data() {
    return {
      isViewable: this.viewable,
    };
  },
  methods: {
    updateViewable: function () {
      this.isViewable = !this.isViewable;
    },
  },
};
</script>

<style scoped>
.container {
  /* background-color: lightgray; */
  max-width: 800px;
  width: 75%;
  margin: 0 auto 2em;
}
.container-content {
  margin-bottom: 0.5em;
}

#title {
  font-size: 1.5em;
}
</style>